<template>
  <div class="app-container">
    <div class="tb" style="height: 100%">
      <div class="main tb">
        <div class="lr between">
          <div style="display: flex;justify-content: flex-start;">
            <el-input v-model="table.query.keyWord" placeholder="请输入关键字查询" clearable
                      suffix-icon="el-icon-search" @change="search(true)" style="width: 217px;"/>
          </div>
          <div style="display: flex;justify-content: flex-end;" v-if="showButton">
            <el-button type="primary" size="small" @click="openDialog(null, false)"
                       icon="el-icon-plus">新增
            </el-button>
          </div>
        </div>
        <div class="main" style="margin-top: 20px;">
          <el-table :data="table.data" height="600px" border
                    :header-cell-style="{background:'#fafafa',color:'#000000'}" v-loading="tableLoading">
            <el-table-column show-overflow-tooltip fixed="left" label="序号" type="index" width="55"
                             align="center"/>
            <el-table-column show-overflow-tooltip label="退款房租" align="center"
                             prop="breakDeposit"></el-table-column>
            <el-table-column show-overflow-tooltip label="违约金/押金" align="center"
                             prop="breakRent"></el-table-column>
            <el-table-column show-overflow-tooltip label="时间" align="center"
                             prop="createDate"></el-table-column>
            <el-table-column show-overflow-tooltip label="类型" align="center"
                             prop="state">
              <template slot-scope="scope">
                <span v-if="scope.row.state == 1">正退</span>
                <span v-if="scope.row.state == 2">违退</span>
              </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip label="备注" align="center"
                             prop="description"></el-table-column>
            <el-table-column show-overflow-tooltip label="操作" width="160" align="center" v-if="showButton">
              <template slot-scope="scope">
                <el-button type="text" @click="openDialog(scope.row, true)">编辑</el-button>
                <el-button type="text" style="color: #ff4949;" @click="deleteData(scope.row.id)">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="lr end" style="margin-top: 20px;">
          <el-pagination :total="table.total" :page-size="table.query.size" :current-page="table.query.page"
                         layout="total, prev, pager, next" @current-change="currentPageChange"/>
        </div>
      </div>
    </div>
    <el-dialog :visible.sync="breakRecordDialog.visible" :close-on-click-modal="false" width="40%"
               :title="!isEdit ? '新增违约记录' : '编辑违约记录'">
      <el-form ref="collectRecordForm" label-position="right" label-width="120px" :model="breakRecordDialog.formData"
               :rules="rules">
        <el-form-item label="出租记录：" prop="rentRecordId">
          <el-select filterable  v-model="breakRecordDialog.formData.rentRecordId" placeholder="请选择出租记录" clearable style="width: 100%;">
            <el-option v-for="item in rentRecords" :key="item.id" :value="item.id"
                       :label="item.startDate + '至' + item.endDate"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="违约金/押金：" prop="breakRent">
          <el-input-number :precision="2" :step="0.1" :min="0" style="width: 100%" v-model="breakRecordDialog.formData.breakRent"
                           clearable/>
        </el-form-item>
        <el-form-item label="备注：" prop="description">
          <el-input type="textarea" :rows="3" placeholder="请输入备注" v-model="breakRecordDialog.formData.description"></el-input>
        </el-form-item>
      </el-form>
      <div class="dialog-btn">
        <el-button @click="breakRecordDialog.visible = false">取消</el-button>
        <el-button type="primary" @click="saveOrUpdateData" :loading="loading">保存</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>

import {getPageList, deleteData, saveOrUpdateData} from "@/api/breakRecord";

export default {
  props: {
    rentRecords: {
      type:Array,
      default: () => []
    },
    rentRecordId: {
      type: Number,
      default: 0
    },
    roomId: {
      type: Number,
      default: 0
    },
    showButton: {
      type: Boolean,
      default: true
    }
  },
  watch: {
    roomId(newVal) {
      if (newVal) {
        this.search(true)
      }
    }
  },
  data() {
    return {
      table: {
        query: {
          page: 1,
          size: 10,
          keyWord: '',
          rentRecordId: ''
        },
        total: 0,
        data: []
      },
      breakRecordDialog: {
        formData: {
          rentRecordId: '',
          breakRent: 0,
          description: ''
        },
        visible: false
      },
      rules: {
        rentRecordId: [
          {trigger: 'change', required: true, message: '请选择出租记录'}
        ],
        breakRent: [
          {trigger: 'change', required: true, message: '请输入租金'}
        ]
      },
      loading: false,
      tableLoading: false,
      isEdit: false
    }
  },
  mounted() {
    this.search(true)
  },
  methods: {
    // 搜索框查询
    search(flag) {
      this.tableLoading = true
      if (flag) {
        this.table.query.page = 1
        this.table.query.keyWord = ''
        this.table.query.communityId = ''
      }
      const params = {
        current: this.table.query.page,
        size: this.table.query.size,
        keyWord: this.table.query.keyWord,
        rentRecordId: this.rentRecordId,
        roomId: this.roomId,
        fromCooperateManage: !this.showButton
      }
      getPageList(params).then(response => {
        if (response.code == 200) {
          // 查询成功
          this.table.data = response.data
          this.table.total = response.count
        } else {
          // 查询失败
          this.$message.error('查询失败!')
        }
        this.tableLoading = false
      })
    },
    // 修改违约记录
    saveOrUpdateData() {
      this.loading = true
      this.$refs['collectRecordForm'].validate(async (valid) => {
        if (valid) {
          saveOrUpdateData(this.breakRecordDialog.formData).then(response => {
            if (response.code == 200) {
              // 操作成功
              this.$message.success('操作成功!')
              this.breakRecordDialog.visible = false
              this.search(false)
            } else {
              // 操作失败
              this.$message.error('操作失败!')
            }
            this.loading = false
          })
        } else {
          this.loading = false
        }
      })
    },
    // 打开弹窗
    openDialog(data, isEdit) {
      this.isEdit = isEdit
      if (!isEdit) {
        // 重置数据
        this.breakRecordDialog.formData = {
          rentRecordId: '',
          breakRent: 0,
          description: ''
        }
      } else {
        this.breakRecordDialog.formData = JSON.parse(JSON.stringify(data))
      }
      this.breakRecordDialog.visible = true
      // 清空验证信息
      this.$nextTick(() => {
        this.$refs.collectRecordForm.clearValidate()
      })
    },
    // 页码变更
    currentPageChange(page) {
      this.table.query.page = page
      this.search(false)
    },
    // 删除违约记录
    deleteData(id) {
      this.$confirm('此操作将永久删除违约记录信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteData(id).then(response => {
          if (response.code == 200) {
            // 操作成功
            this.$message.success('操作成功!')
            this.search(false)
          } else {
            // 操作失败
            this.$message.error(response.data)
          }
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/BreakRecord.vue